import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import {
    IPrCareReceiverEntity,
    IPrCSSZSubmissionMaternityLeaveEntity,
    PrCareReceiverEntity,
    PrCSSZSubmissionMaternityLeaveDetailEntity,
    PrCSSZSubmissionMaternityLeaveEntity
} from "@odata/GeneratedEntityTypes";
import { PrMaternityLeaveEntitlementCode, PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import {
    handleIdentificationTypeBeforeSave,
    initIdentificationTypeLocalPath
} from "@pages/payroll/employee/Employee.utils";
import {
    initHasPensionLocalPath,
    pensionBeforeSaveAdjustments
} from "@pages/payroll/submission/submissionTypes/PrCSSZSubmission.utils";
import { addCareReceiverEmptyRow } from "@pages/payroll/submission/submissionTypes/PrCSSZSubmissionMaternityLeave.def";
import PrCSSZSubmissionNEMPRIFormView from "@pages/payroll/submission/submissionTypes/PrCSSZSubmissionNEMPRIFormView";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class PrCSSZSubmissionMaternityLeaveFormView extends PrCSSZSubmissionNEMPRIFormView<IPrCSSZSubmissionMaternityLeaveEntity> {
    typeCode = PrSubmissionTypeCode.EmployersNotificationOfAnEmployeesBenefitApplication;
    subTypeCode = PrSubmissionSubtypeCode.NempriMaternityLeave;

    typeSpecificOnAfterLoad(isNew: boolean): Promise<void> {
        const { storage } = this.props;

        // init local contexts from data
        const childrenBc = storage.data.bindingContext
            .navigate(PrCSSZSubmissionMaternityLeaveEntity.Detail)
            .navigate(PrCSSZSubmissionMaternityLeaveDetailEntity.Children);
        const children: IPrCareReceiverEntity[] = storage.getValue(childrenBc);
        children?.forEach((item) => {
            const itemBc = childrenBc.addKey(item);
            initIdentificationTypeLocalPath(storage, itemBc, PrCareReceiverEntity.IdentificationNumber);
        });

        initHasPensionLocalPath(storage);

        return super.typeSpecificOnAfterLoad(isNew);
    }

    handleChange(e: ISmartFieldChange): void {
        const { storage } = this.props;

        if (e.bindingContext.getPath() === PrCSSZSubmissionMaternityLeaveDetailEntity.MaternityReason && e.triggerAdditionalTasks) {
            const childrenBc = storage.data.bindingContext
                .navigate(PrCSSZSubmissionMaternityLeaveEntity.Detail)
                .navigate(PrCSSZSubmissionMaternityLeaveDetailEntity.Children);

            if (e.value && e.value !== PrMaternityLeaveEntitlementCode.GivingBirth) {
                const children = storage.getValue(childrenBc);
                if (!children || children.length === 0) {
                    addCareReceiverEmptyRow(storage, childrenBc);
                }
            } else {
                storage.setValue(childrenBc, []);
            }
            storage.refresh(true);
        }

        super.handleChange(e);
        // keep after storage -> handleChange to have updated data
    }

    onBeforeSave(data?: IPrCSSZSubmissionMaternityLeaveEntity): IPrCSSZSubmissionMaternityLeaveEntity {
        const { storage } = this.props;
        data = super.onBeforeSave(data);

        data = pensionBeforeSaveAdjustments(data, this.props.storage);
        if (data.Detail?.MaternityReason) {
            const childrenBc = storage.data.bindingContext
                .navigate(PrCSSZSubmissionMaternityLeaveEntity.Detail)
                .navigate(PrCSSZSubmissionMaternityLeaveDetailEntity.Children);

            data.Detail?.Children?.forEach((item, idx) => {
                item.Order = idx + 1;
                const childBc = childrenBc.addKey(item);
                handleIdentificationTypeBeforeSave(data, storage.data.bindingContext, childBc,
                    { identificationPropName: PrCareReceiverEntity.IdentificationNumber });
            });
        }

        return data;
    }
}

export default withPermissionContext(PrCSSZSubmissionMaternityLeaveFormView);